"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var ScrollHandler = function () {
  function ScrollHandler() {
    _classCallCheck(this, ScrollHandler);
  }

  _createClass(ScrollHandler, null, [{
    key: "getCurrentScrollPosition",
    value: function getCurrentScrollPosition() {
      var documentElement = document.documentElement;
      var documentRect = documentElement.getBoundingClientRect();
      var top = -documentRect.top || document.body.scrollTop || window.scrollY || documentElement.scrollTop || 0;
      var left = -documentRect.left || document.body.scrollLeft || window.scrollX || documentElement.scrollLeft || 0;
      return {
        top: top,
        left: left
      };
    }
  }, {
    key: "disableScroll",
    value: function disableScroll() {
      this.openSubMenuCount++;

      if (this.openSubMenuCount === 1) {
        this.currentScrollPosition = this.getCurrentScrollPosition();
        document.documentElement.style.left = -this.currentScrollPosition.left + "px";
        document.documentElement.style.top = -this.currentScrollPosition.top + "px";

        if (document.body.scrollHeight > document.body.clientHeight) {
          document.documentElement.classList.add("cdk-scroll-block--hide-scrollbar");
        } else {
          document.documentElement.classList.add("cdk-scroll-block--show-scrollbar");
        }
      }
    }
  }, {
    key: "enableScroll",
    value: function enableScroll() {
      this.openSubMenuCount--;

      if (this.openSubMenuCount === 0) {
        document.documentElement.classList.remove("cdk-scroll-block--hide-scrollbar");
        document.documentElement.classList.remove("cdk-scroll-block--show-scrollbar");
        window.scroll(this.currentScrollPosition.left, this.currentScrollPosition.top);
      }
    }
  }]);

  return ScrollHandler;
}();

ScrollHandler.openSubMenuCount = 0;
ScrollHandler.currentScrollPosition = {};
exports.default = ScrollHandler;